// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kL9f","rootNoMargin":"styles_rootNoMargin__36JET"};